import { UPDATE_FLASH_MESSAGE, RESET_FLASH_MESSAGE } from '../store/actionTypes';

type ArgType = {
  payload: {
    open: boolean;
    message: string;
    severity: string;
  };
  type: string;
};

export const dispatchReduxError = (dispatch: ({ type, payload }: ArgType) => void) => {
  dispatch({
    type: UPDATE_FLASH_MESSAGE,
    payload: {
      open: true,
      message: 'Unable to perform action',
      severity: 'error',
    },
  });

  setTimeout(() => {
    dispatch({
      type: RESET_FLASH_MESSAGE,
      payload: {
        open: false,
        message: '',
        severity: 'error',
      },
    });
  }, 5000);
};
